module.exports = __webpack_public_path__ + "media/impact3.6dbef563.mp3";